// Import Tailwind CSS
import '../css/tailwind.css';

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import AOS (Animate On Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import all images from src/images directory
// This makes webpack process and copy them to dist/images
function importAll(r) {
  return r.keys().map(r);
}
importAll(require.context('../images', false, /\.(png|jpe?g|svg|gif)$/));

// Main JavaScript file
console.log('Webpack + Tailwind v4 setup is working!');

// Initialize AOS (Animate On Scroll)
AOS.init({
  duration: 800, // Animation duration in milliseconds
  easing: 'ease-in-out', // Easing function
  once: true, // Whether animation should happen only once
  offset: 100, // Offset (in px) from the original trigger point
  delay: 0, // Delay animation (ms)
  anchorPlacement: 'top-bottom', // Defines which position of the element should trigger animation
});

// Add your custom JavaScript here
// Example: Initialize components, add event listeners, etc.

// Hot Module Replacement (HMR) for development
if (module.hot) {
  module.hot.accept();
}
